import crossSvg from '@/assets/images/cross.svg';
import appleLogoPng from '@/assets/images/apple.png';

import articleSvg from '@/assets/images/article.svg';
import unionSvg from '@/assets/images/union.svg';
import editSvg from '@/assets/images/edit.svg';
import editWhiteSvg from '@/assets/images/edit_white.svg';
import addTimeRangeSvg from '@/assets/images/add_time_range.svg';
import deleteTimeRangeSvg from '@/assets/images/delete_time_range.svg';
import copyToAllSvg from '@/assets/images/copy_to_all.svg';
import copySvg from '@/assets/images/copy.svg';
import shareSvg from '@/assets/images/share.svg';
import toolTipSvg from '@/assets/images/tooltip.svg';
import qrcodeSvg from '@/assets/images/qrcode.svg';
import plusSvg from '@/assets/images/plus.svg';
import minusSvg from '@/assets/images/minus.svg';
import deleteSvg from '@/assets/images/delete.svg';
import addSvg from '@/assets/images/add.svg';
import locationSvg from '@/assets/images/location.svg';
import infoSvg from '@/assets/images/info.svg';
import successCheckSvg from '@/assets/images/success_check.svg';
import garbageDeleteSvg from '@/assets/images/garbage_delete.svg';

import cardSvg1 from '@/assets/images/card_img_1.svg';
import cardSvg2 from '@/assets/images/card_img_2.svg';
import cardSvg3 from '@/assets/images/card_img_3.svg';

import ellipseSvg from '@/assets/images/ellipse.svg';
import filterSvg from '@/assets/images/filter.svg';
import searchSvg from '@/assets/images/search.svg';

import createBrandConnectorSvg from '@/assets/images/connector.svg';
import noImagePlaceholderSvg from '@/assets/images/no_image_placeholder.svg';
import errorWhiteSvg from '@/assets/images/error_white.svg';

import channelSetupSearchSvg from '@/assets/images/channel_setup_search.svg';
import learnMoreSvg from '@/assets/images/learn_more.svg';
import WhatsAppSvg from '@/assets/images/WhatsApp.svg';
import appleSvg from '@/assets/images/apple.svg';
import facebookPng from '@/assets/images/facebook.png';
import googlePng from '@/assets/images/google.png';
import instagramPng from '@/assets/images/instagram.png';
import kakaoTalkSvg from '@/assets/images/kakao_talk.svg';
import linePng from '@/assets/images/line.png';
import mobileAppPng from '@/assets/images/mobile_app.png';
import smsSvg from '@/assets/images/sms.svg';
import twitterPng from '@/assets/images/twitter.png';
import viberPng from '@/assets/images/viber.png';
import weChatPng from '@/assets/images/we_chat.png';
import webPng from '@/assets/images/web.png';
import backSvg from '@/assets/images/back.svg';
import voiceAISvg from '@/assets/images/voiceAI.svg';

import ambPlusSvg from '@/assets/images/amb_plus.svg';
import createConnectorSvg from '@/assets/images/create_connector.svg';
import selectAccountType from '@/assets/images/select_account_type';
import selectMessagingPlatformUs from '@/assets/images/select_messaging_platform_us';
import selectMessagingPlatformQa from '@/assets/images/select_messaging_platform_qa';
import selectMessagingPlatformAlpha from '@/assets/images/select_messaging_platform_alpha';
import selectOtherMessagingPlatform from '@/assets/images/select_other_messaging_platform';
import turnOnAccount from '@/assets/images/turn_on_account';
import activateEntryPoints from '@/assets/images/activate_entry_points';
import sendAccountToReview from '@/assets/images/send_account_to_review';

import accordionBtnSvg from '@/assets/images/accordion_btn.svg';
import externalLinkSvg from '@/assets/images/external_link.svg';

import phoneSvg from '@/assets/images/phone.svg';
import twilioSvg from '@/assets/images/twilio.svg';
import telnyxSvg from '@/assets/images/telnyx.svg';

import WhatsAppLogoPng from '@/assets/images/whatsappLogo.png';
import BlankPhotoSvg from '@/assets/images/blank_photo.svg';

import attentionSvg from '@/assets/images/attention.svg';

import emailConnectLogo from '@/assets/images/emailConnect_logo.svg';
import emailConnectOutlookGmailLogo from '@/assets/images/emailConnect_outlook_gmail_logo.png';
import yellowWarning from '@/assets/images/yellow_warning.png';
import downloadIcon from '@/assets/images/download_icon.svg';

export const appCode = 'ccm';

export const appName = 'lp-le-conversational-connectors-management';

export const IMAGES = {
  SVG: {
    cross: crossSvg,
    article: articleSvg,
    ellipse: ellipseSvg,
    filter: filterSvg,
    union: unionSvg,
    edit: editSvg,
    editWhite: editWhiteSvg,
    noImagePlaceholder: noImagePlaceholderSvg,
    addTimeRange: addTimeRangeSvg,
    deleteTimeRange: deleteTimeRangeSvg,
    copyToAll: copyToAllSvg,
    copy: copySvg,
    share: shareSvg,
    toolTip: toolTipSvg,
    qrcode: qrcodeSvg,
    search: searchSvg,
    plus: plusSvg,
    minus: minusSvg,
    delete: deleteSvg,
    add: addSvg,
    location: locationSvg,
    info: infoSvg,
    successCheck: successCheckSvg,
    garbageDelete: garbageDeleteSvg,
    errorWhite: errorWhiteSvg,
    accordionBtn: accordionBtnSvg,
    externalLink: externalLinkSvg,
    createConnector: createConnectorSvg,
    attention: attentionSvg,
    AMB: {
      logo: appleLogoPng,
      cards: [cardSvg1, cardSvg3],
      stepper: {
        createBrandConnector: createBrandConnectorSvg,
      },
      plus: ambPlusSvg,
      createConnector: createConnectorSvg,
      selectAccountType,
      selectMessagingPlatformUs,
      selectMessagingPlatformQa,
      selectMessagingPlatformAlpha,
      selectOtherMessagingPlatform,
      sendAccountToReview,
      turnOnAccount,
      activateEntryPoints,
    },
    SMS: {
      logo: smsSvg,
      cards: [cardSvg1, cardSvg2, cardSvg3],
      phone: phoneSvg,
      telnyx: telnyxSvg,
      twilio: twilioSvg,
    },
    WA: {
      logo: WhatsAppLogoPng,
      cards: [cardSvg1, cardSvg2, cardSvg3],
      blankPhoto: BlankPhotoSvg,
    },
    EC: {
      logo: emailConnectLogo,
      outlookGmailLogos: emailConnectOutlookGmailLogo,
      download: downloadIcon,
      yellowWarning: yellowWarning,
    },
    ChannelSetup: {
      search: channelSetupSearchSvg,
      learnMore: learnMoreSvg,
      WhatsApp: WhatsAppSvg,
      apple: appleSvg,
      google: googlePng,
      facebook: facebookPng,
      instagram: instagramPng,
      kakaoTalk: kakaoTalkSvg,
      line: linePng,
      mobileApp: mobileAppPng,
      sms: smsSvg,
      twitter: twitterPng,
      viber: viberPng,
      weChat: weChatPng,
      web: webPng,
      back: backSvg,
      voiceAI: voiceAISvg,
    },
  },
};

export const notifierTimers = {
  warning: 10000,
};

export const entryPoints = {
  LOCATION: 'LOCATION',
  NON_LOCAL: 'NON_LOCAL',
};

export const verificationStatus = {
  VERIFICATION_STATE_UNSPECIFIED: 'VERIFICATION_STATE_UNSPECIFIED',
  VERIFICATION_STATE_UNVERIFIED: 'VERIFICATION_STATE_UNVERIFIED',
  VERIFICATION_STATE_PENDING: 'VERIFICATION_STATE_PENDING',
  VERIFICATION_STATE_VERIFIED: 'VERIFICATION_STATE_VERIFIED',
  VERIFICATION_STATE_SUSPENDED_IN_GMB: 'VERIFICATION_STATE_SUSPENDED_IN_GMB',
};

export const launchStatus = {
  LAUNCH_STATE_UNSPECIFIED: 'LAUNCH_STATE_UNSPECIFIED',
  LAUNCH_STATE_UNLAUNCHED: 'LAUNCH_STATE_UNLAUNCHED',
  LAUNCH_STATE_PENDING: 'LAUNCH_STATE_PENDING',
  LAUNCH_STATE_LAUNCHED: 'LAUNCH_STATE_LAUNCHED',
  LAUNCH_STATE_REJECTED: 'LAUNCH_STATE_REJECTED',
  LAUNCH_STATE_SUSPENDED: 'LAUNCH_STATE_SUSPENDED',
  LAUNCH_STATE_PENDING_UNLAUNCH: 'LAUNCH_STATE_PENDING_UNLAUNCH',
  LAUNCH_STATE_INVALID_IN_GMB: 'LAUNCH_STATE_INVALID_IN_GMB',
};

export const modalType = {
  DISCARD_CHANGES: 'discardChanges',
  LAUNCH: 'launch',
  COMPLETE: 'complete',
  CONFIRM: 'confirm',
  SUCCESS: 'success',
  SKILL: 'skill',
  VERIFY_AGENT: 'verifyAgent',
  VERIFY_LOCATIONS: 'verifyLocations',
  CREATE_BRAND: 'createBrand',
  DELETE_CONNECTOR: 'deleteConnector',
  CREATE_AMB_CONNECTOR: 'createAmbConnector',
  APPLE_BUSINESS_ACCOUNT: 'appleBusinessAccount',
  CREATE_SMS_CONNECTOR: 'createSmsConnector',
  CREATE_WA_CONNECTOR: 'createWAConnector',
};

export const E164PhoneNumberFormatRegex = /^\+[1-9]\d{9,13}$/;

export const UUIDRegex =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const conversationLanguages = [
  { value: 'Afrikaans', locale: 'af', id: 1 },
  { value: 'Arabic', locale: 'ar', id: 2 },
  { value: 'Chinese - Hong Kong', locale: 'zh_HK', id: 3 },
  { value: 'Dutch', locale: 'nl', id: 4 },
  { value: 'English', locale: 'en', id: 5 },
  { value: 'French', locale: 'fr', id: 6 },
  { value: 'German', locale: 'de', id: 7 },
  { value: 'Hebrew', locale: 'he', id: 8 },
  { value: 'Italian', locale: 'it', id: 9 },
  { value: 'Portuguese (Brazil)', locale: 'pt_BR', id: 10 },
  { value: 'Russian', locale: 'ru', id: 11 },
  { value: 'Slovenian', locale: 'sl', id: 12 },
  { value: 'Spanish', locale: 'es', id: 13 },
  { value: 'Swedish', locale: 'sv', id: 14 },
];

export const businessVerticals = [
  { id: 1, value: 'Automotive' },
  { id: 3, value: 'Beauty, Spa and Salon' },
  { id: 4, value: 'Clothing and Apparel' },
  { id: 5, value: 'Education' },
  { id: 2, value: 'Entertainment' },
  { id: 6, value: 'Event Planning and Service' },
  { id: 7, value: 'Finance and Banking' },
  { id: 8, value: 'Food and Grocery' },
  { id: 9, value: 'Public Service' },
  { id: 10, value: 'Hotel and Lodging' },
  { id: 11, value: 'Medical and Health' },
  { id: 12, value: 'Non-profit' },
  { id: 13, value: 'Professional Service' },
  { id: 14, value: 'Shopping and Retail' },
  { id: 15, value: 'Travel and Transportation' },
  { id: 16, value: 'Restaurant' },
  { id: 17, value: 'Other' },
];

export const ACCOUNT_MODE_STATE = Object.freeze({
  SANDBOX: 'SANDBOX',
  LIVE: 'LIVE',
  DEPLOYMENT: 'DEPLOYMENT',
});
export const NAME_STATUS = Object.freeze({
  SANDBOX: 'SANDBOX',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  EXPIRED: 'EXPIRED',
  PENDING_REVIEW: 'PENDING_REVIEW',
  VERIFIED: 'VERIFIED',
  UNVERIFIED: 'UNVERIFIED',
  AVAILABLE_WITHOUT_REVIEW: 'AVAILABLE_WITHOUT_REVIEW',
  NONE: 'NONE',
});
export const VERIFICATION_STATE = Object.freeze({
  SANDBOX: 'sandbox',
  PENDING_VERIFICATION: 'pendingVerification',
  VERIFIED: 'verified',
  UNVERIFIED: 'unverified',
  DEPLOYMENT: 'deployment',
  EXPIRED: 'expired',
  REJECTED: 'rejected',
});

export const STATUS = Object.freeze({
  DISCONNECTED: 'DISCONNECTED',
  CONNECTED: 'CONNECTED',
  PENDING: 'PENDING',
});
export const errorCodes = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  FORBIDDEN: 403,
};

export const ChannelStates = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  NOT_IN_PLAN: 'notInPlan',
};

export const PRIVILEGES = {
  VIEW_AND_ACCESS_MODULE: '1730',
  ALLOWED_ROLES: ['admin', 'campaignManager'],
};

export const WelComeCardActions = {
  SHOW_VIDEO: 'Show Video',
  OPEN_GUIDE: 'Open Guide',
};

export const connectorTypes = {
  AMB: '106',
};

export const AccountZones = {
  qa: 'qa',
  z0: 'z0',
  alpha: 'z1-a',
  z1: 'z1',
  z2: 'z2',
  z3: 'z3',
};

export const skillRoutingSource = {
  AMB: 'AMB',
  SMS: 'SMS',
  WHATSAPP: 'WhatsApp',
  EMAIL: 'EmailConnect',
};

export const smsProviders = {
  TWILIO: 'twilio',
  TELNYX: 'telnyx',
};

export const LAUNCH_DARKLY_ENVIRONMENTS = {
  LD_CLIENT_SITE_ID: 'ldClientSideId',
};

export const LAUNCH_DARKLY_FEATURE_FLAGS = {
  TEST_FEATURE_FLAG: { key: 'TEST_FEATURE_FLAG', defaultValue: false },
  USE_CONFIG_ID_FB_LOGIN: { key: 'USE_CONFIG_ID_FB_LOGIN', defaultValue: true },
  DISPLAY_NEW_WA_UI: { key: 'DISPLAY_NEW_WA_UI', defaultValue: false },
  ENABLE_EMAIL_CONNECT: { key: 'ENABLE_EMAIL_CONNECT', defaultValue: false },
};

export const EMAIL_PROVIDERS = {
  GOOGLE: { VALUE: 'google', ID: '1' },
  MICROSOFT: { VALUE: 'microsoft', ID: '2' },
  IMAP: { VALUE: 'imap', ID: '3' },
};

export const NYLAS_GRANT_STATUS = {
  CREATED: 'CREATED',
  UPDATED: 'UPDATED',
  DELETED: 'DELETED',
  EXPIRED: 'EXPIRED',
};

export const FB_SDK_VERSION = 'v18.0';
